import { InputHTMLAttributes } from 'react';
import { Container } from '../styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  size?: number;
  value: string;
  isError: boolean;
}

export const InputCPFMask = ({
  name,
  label,
  size,
  value,
  isError,
  ...rest
}: InputProps) => {
  function mask(value: string) {
    if (value.length >= 15) {
      return value
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    } else {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    }
  }

  return (
    <Container error={isError}>
      <label htmlFor={name}>{label}</label>
      <input
        value={mask(value)}
        name={name}
        maxLength={18}
        style={{ width: size }}
        {...rest}
      />
    </Container>
  );
};
